module.exports = __webpack_public_path__ + "img/icon-question-rating-radiobutton-hover.a5cb2fbf.svg";